import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroBannerPorcelainPaving from "./sections/HeroBannerPorcelainPaving";
import CategoryQuickLinks from "./sections/CategoryQuickLinks";
import CategoryQuickLinksCopy from "./sections/CategoryQuickLinksCopy";
import TradeAccountBanner from "./sections/TradeAccountBanner";
import TradeAccountBannerCopy from "./sections/TradeAccountBannerCopy";
import NewStoneRange from "./sections/NewStoneRange";
import CompositeDeckingFeature from "./sections/CompositeDeckingFeature";
import NationwideShowrooms10 from "./sections/10NationwideShowrooms";
import ShowroomLocationTiles from "./sections/ShowroomLocationTiles";
import StepsCopings from "./sections/StepsCopings";
import MetalPergolasFeature from "./sections/MetalPergolasFeature";
import ServiceTrustBadges from "./sections/ServiceTrustBadges";
import ThisislondonstoneUgcGallery from "./sections/ThisislondonstoneUgcGallery";
import CustomerTestimonials from "./sections/CustomerTestimonials";
import AreasWeCover from "./sections/AreasWeCover";
import Footer from "@/reusable_sections/Footer";
import FaqAccordion from "./sections/FaqAccordion";
import GardenInquiryForm from "./sections/GardenInquiryForm";
import Instagramfeed from "./sections/Instagramfeed";
export default function HomePage() {
  return <div>
      <Header />
      <HeroBannerPorcelainPaving />
      <CategoryQuickLinks />
      <CategoryQuickLinksCopy />
      <TradeAccountBanner />
      <CustomerTestimonials />
      <Instagramfeed />
      <AreasWeCover />
      <TradeAccountBannerCopy />
      <NewStoneRange />
      <CompositeDeckingFeature />
      <NationwideShowrooms10 />
      <ShowroomLocationTiles />
      <StepsCopings />
      <MetalPergolasFeature />
      <ServiceTrustBadges />
      <ThisislondonstoneUgcGallery />
      <FaqAccordion />
      <GardenInquiryForm />
      <Footer />
    </div>;
}